// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  background: #f7f7f7;\n  width: 100%;\n  height: 100%;\n  font-family: sans-serif;\n}\n\na {\n  text-decoration: none !important;\n}\n\na:hover {\n  color: #041e42;\n}\n\n#modal-backdrop {\n  z-index: 100000 !important;\n}\n\n#modal {\n  z-index: 100001 !important;\n}\n\n.fa-exclamation-circle {\n  color: #ff9300;\n}\n\n.PhoneInputInput {\n  border: none;\n  outline: none;\n}\n", ""]);
// Exports
module.exports = exports;
